import { render, staticRenderFns } from "./TicketDetailsView.vue?vue&type=template&id=2d72ef52&scoped=true"
import script from "./TicketDetailsView.vue?vue&type=script&lang=ts"
export * from "./TicketDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./TicketDetailsView.vue?vue&type=style&index=0&id=2d72ef52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72ef52",
  null
  
)

export default component.exports